import { useQuery } from "react-query";
import { userProfileAPI } from "../axios/userProfile";
import { getAdminProfile, IAdminSession } from "../axios/adminProfile";
import { useSelect } from "./useSelect";
import { IUser } from "../Components/BrandSettings/DashboardUsers/users-hooks";

const isAdminRemote = () =>
  localStorage.getItem("isKoinzAdminRemote") &&
  localStorage.getItem("isRemoteAuthentication");

export const useUserProfileQuery = () => {
  const token = useSelect((state) => state.authReducer.token);
  const admin = isAdminRemote();

  return useQuery<IUser | IAdminSession, Error>(
    admin ? "adminProfile" : "userProfile",
    () => {
      if (admin) return getAdminProfile(token);
      return userProfileAPI(token).then((res) => res.data);
    },
    {
      enabled: !!token,
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
    }
  );
};